import { render } from "./TenantManagementLegacy.vue?vue&type=template&id=137baaae"
import script from "./TenantManagementLegacy.vue?vue&type=script&lang=js"
export * from "./TenantManagementLegacy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__